import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "filter" }
const _hoisted_4 = { class: "filter-and-button-container" }
const _hoisted_5 = { class: "filter-container" }
const _hoisted_6 = {
  key: 0,
  class: "switch-container"
}
const _hoisted_7 = {
  key: 1,
  class: "button-container"
}
const _hoisted_8 = { class: "switch-container" }
const _hoisted_9 = {
  class: "switch-label",
  id: "label-vision"
}
const _hoisted_10 = {
  class: "switch-option-left",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  class: "switch-option-right",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "switch-container" }
const _hoisted_13 = {
  class: "switch-label",
  id: "label-intervention"
}
const _hoisted_14 = {
  class: "switch-option-left",
  "aria-hidden": "true"
}
const _hoisted_15 = {
  class: "switch-option-right",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "width" }
const _hoisted_17 = { class: "switch-label" }
const _hoisted_18 = { class: "button-container" }
const _hoisted_19 = { class: "selection-actions-row" }
const _hoisted_20 = { class: "switch-container" }
const _hoisted_21 = {
  class: "switch-label",
  id: "label-selection-rapport"
}
const _hoisted_22 = {
  class: "switch-option-left",
  "aria-hidden": "true"
}
const _hoisted_23 = {
  class: "switch-option-right",
  "aria-hidden": "true"
}
const _hoisted_24 = { class: "right-actions" }
const _hoisted_25 = {
  key: 0,
  class: "selection-counter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_AnneeChips = _resolveComponent("AnneeChips")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_TreeGrid = _resolveComponent("TreeGrid")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_EquipementModal = _resolveComponent("EquipementModal")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!
  const _component_ModalChoixNomZip = _resolveComponent("ModalChoixNomZip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isUniqueSite || !_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('preventif.suivi.title')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "interventionPreventive.definition" }),
              _createVNode(_component_ReglePastille, { cle: "planningPreventif.portee" })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('title.filter')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (!_ctx.isUniqueSite)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_TextInput, {
                        label: _ctx.$t('preventive.filter.site'),
                        modelValue: _ctx.siteFilter,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.siteFilter) = $event))
                      }, null, 8, ["label", "modelValue"]),
                      _createVNode(_component_ReglePastille, { cle: "planningPreventif.filtreSiteUnique" })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isUniqueSite)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_ButtonBlue, {
                        class: "button-confirm btn",
                        name: "confirm",
                        onClick: _ctx.changerSite,
                        text: _ctx.$t('bouton.choix.site')
                      }, null, 8, ["onClick", "text"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t('preventive.filter.vision')) + " ", 1),
                    _createVNode(_component_ReglePastille, { cle: "planningPreventif.visionPeriode" })
                  ]),
                  _createElementVNode("div", {
                    class: "switch-wrapper",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchVision && _ctx.switchVision(...args)), ["stop"])),
                    onKeydown: [
                      _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.switchVision && _ctx.switchVision(...args)), ["prevent"]), ["enter"])),
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.switchVision && _ctx.switchVision(...args)), ["prevent"]), ["space"]))
                    ],
                    tabindex: "0",
                    role: "button",
                    "aria-labelledby": "label-vision"
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('preventive.filter.mensuelVision')), 1),
                    _createVNode(_component_Switch, { active: _ctx.isWeek }, null, 8, ["active"]),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('preventive.filter.weekVision')), 1)
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.$t('preventive.filter.intervention')) + " ", 1),
                    _createVNode(_component_ReglePastille, { cle: "planningPreventif.visionReel" })
                  ]),
                  _createElementVNode("div", {
                    class: "switch-wrapper",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchIntervention && _ctx.switchIntervention(...args)), ["stop"])),
                    onKeydown: [
                      _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.switchIntervention && _ctx.switchIntervention(...args)), ["prevent"]), ["enter"])),
                      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.switchIntervention && _ctx.switchIntervention(...args)), ["prevent"]), ["space"]))
                    ],
                    tabindex: "0",
                    role: "button",
                    "aria-labelledby": "label-intervention"
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('preventive.filter.previsionnel')), 1),
                    _createVNode(_component_Switch, { active: _ctx.isReel }, null, 8, ["active"]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('preventive.filter.reel')), 1)
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('preventive.filter.goto')), 1),
                  _createVNode(_component_AnneeChips, { onSelect: _ctx.showCompleteYear }, null, 8, ["onSelect"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_BorderedIconButton, {
                  onClick: _ctx.exportXls,
                  imgUrl: _ctx.iconeXls,
                  title: _ctx.$t('list.export')
                }, null, 8, ["onClick", "imgUrl", "title"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.$t('preventive.filter.selectionRapport')) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "planningPreventif.selectionRapports" })
                ]),
                _createElementVNode("div", {
                  class: "switch-wrapper",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSelectionMode && _ctx.toggleSelectionMode(...args)), ["stop"])),
                  onKeydown: [
                    _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSelectionMode && _ctx.toggleSelectionMode(...args)), ["prevent"]), ["enter"])),
                    _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSelectionMode && _ctx.toggleSelectionMode(...args)), ["prevent"]), ["space"]))
                  ],
                  tabindex: "0",
                  role: "button",
                  "aria-labelledby": "label-selection-rapport"
                }, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('preventive.filter.selectionRapportNon')), 1),
                  _createVNode(_component_Switch, { active: _ctx.selectionMode }, null, 8, ["active"]),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('preventive.filter.selectionRapportOui')), 1)
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_24, [
                (_ctx.selectionMode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('preventive.filter.rapportSelectionne', _ctx.selectedCells.length, { count: _ctx.selectedCells.length })), 1))
                  : _createCommentVNode("", true),
                (_ctx.selectionMode && _ctx.selectedInterventionIds.length > 0)
                  ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                      key: 1,
                      onClick: _ctx.downloadSelected,
                      imgUrl: _ctx.iconeDownload,
                      title: _ctx.$t('list.download.selection')
                    }, null, 8, ["onClick", "imgUrl", "title"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "planning-container",
            onScroll: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
            ref: "siteListPlannning"
          }, [
            (_ctx.grid)
              ? (_openBlock(), _createBlock(_component_TreeGrid, {
                  key: 0,
                  onNext: _ctx.next,
                  onPrevious: _ctx.previous,
                  onEmitOpenModal: _ctx.openModal,
                  isWeek: _ctx.isWeek,
                  gridData: _ctx.grid,
                  gridHeader: _ctx.gridHeader,
                  isLoading: _ctx.loading && _ctx.isEmptyList,
                  gridHeaderAll: _ctx.gridHeaderAll,
                  "other-data-loading": !_ctx.isAllData && _ctx.loading,
                  "selection-mode": _ctx.selectionMode,
                  "selected-report-ids": _ctx.documentListToDownload,
                  "selected-ui-ids": _ctx.selectedUiIds,
                  onCellClick: _ctx.onCellClick
                }, null, 8, ["onNext", "onPrevious", "onEmitOpenModal", "isWeek", "gridData", "gridHeader", "isLoading", "gridHeaderAll", "other-data-loading", "selection-mode", "selected-report-ids", "selected-ui-ids", "onCellClick"]))
              : _createCommentVNode("", true)
          ], 544),
          (_ctx.isExportXlsLoading || _ctx.isRapportLoading)
            ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.modaleActive)
      ? (_openBlock(), _createBlock(_component_EquipementModal, {
          key: 1,
          preventif: true
        }))
      : _createCommentVNode("", true),
    (_ctx.displayModalChoixSite && !_ctx.isUniqueSite)
      ? (_openBlock(), _createBlock(_component_ModalChoixSite, {
          key: 2,
          onCancel: _ctx.modalChoixSiteCancel,
          onValider: _ctx.validerSite,
          "selected-site": _ctx.selectedSite,
          "selected-sites": null,
          "is-multi-site": false,
          "inclure-termines": true,
          "sites-autorises": _ctx.sitesDashboard,
          "sous-titre": _ctx.$t('preventif.suivi.modal.choix.titre'),
          "regle-cle": "planningPreventif.choixUnOuTousSites"
        }, null, 8, ["onCancel", "onValider", "selected-site", "sites-autorises", "sous-titre"]))
      : _createCommentVNode("", true),
    (_ctx.showModalNomZip)
      ? (_openBlock(), _createBlock(_component_ModalChoixNomZip, {
          key: 3,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showModalNomZip = false)),
          onDownload: _ctx.downloadDocuments
        }, null, 8, ["onDownload"]))
      : _createCommentVNode("", true)
  ], 64))
}